// // import React, { useState, useEffect } from 'react';
// // import { FaSave, FaPlus, FaTrash, FaUpload, FaEdit } from 'react-icons/fa';

// // const AdminPanel = () => {
// //   // Stan dla treści i obrazów
// //   const [aboutData, setAboutData] = useState({
// //     title: "O nas",
// //     paragraphs: [
// //       "Jeśli marzysz o wypoczynku nad morzem z rodziną, Kolorowe Domki to idealne miejsce! Już od 2013 roku zapewniamy niezapomnianą atmosferę naszym Gościom – zarówno najmłodszym, jak i starszym. Oferujemy komfortowe drewniane domki dla 4-6 osób oraz przestronne Apartamenty Kolorowe Domki dla 4-8 osób.",
// //       "Nasze obiekty znajdują się w malowniczej Jastrzębiej Górze, w pobliżu Rozewia i jego latarni morskiej. Spokojna okolica sprzyja relaksowi, a bliskość plaży oraz tras pieszych i rowerowych gwarantuje aktywny wypoczynek. W okresie letnim organizujemy specjalne atrakcje: dzień z naleśnikami dla dzieci i wieczory z rybami dla dorosłych.",
// //       "Gościom zapewniamy miejsce parkingowe oraz przestrzeń do zabawy i grillowania. Do plaży prowadzą wygodne zejścia – wybetonowane nr 20 oraz malownicze „Lisi Jar” nr 19.",
// //       "Zapraszamy na rodzinny wypoczynek nad morzem!"
// //     ],
// //     boldText: "Zapewniamy miejsca parkingowe dla naszych Gości w cenie wynajmu.",
// //     images: [
// //       "/images/aboutuspicture1.jpg",
// //       "/images/aboutuspicture2.jpg"
// //     ]
// //   });

// //   const [newParagraph, setNewParagraph] = useState("");
// //   const [editingIndex, setEditingIndex] = useState(null);
// //   const [message, setMessage] = useState("");
// //   const [imageUploading, setImageUploading] = useState(false);

// //   // Załaduj dane z localStorage przy starcie
// //   useEffect(() => {
// //     const savedData = localStorage.getItem('aboutData');
// //     if (savedData) {
// //       setAboutData(JSON.parse(savedData));
// //     }
// //   }, []);

// //   const saveData = () => {
// //     localStorage.setItem('aboutData', JSON.stringify(aboutData));
// //     setMessage("Zmiany zapisane pomyślnie!");
// //     setTimeout(() => setMessage(""), 3000);
// //   };

// //   const handleTitleChange = (e) => {
// //     setAboutData({ ...aboutData, title: e.target.value });
// //   };

// //   const handleParagraphChange = (index, value) => {
// //     const newParagraphs = [...aboutData.paragraphs];
// //     newParagraphs[index] = value;
// //     setAboutData({ ...aboutData, paragraphs: newParagraphs });
// //   };

// //   const handleBoldTextChange = (e) => {
// //     setAboutData({ ...aboutData, boldText: e.target.value });
// //   };

// //   const addParagraph = () => {
// //     if (newParagraph.trim()) {
// //       setAboutData({
// //         ...aboutData,
// //         paragraphs: [...aboutData.paragraphs, newParagraph]
// //       });
// //       setNewParagraph("");
// //     }
// //   };

// //   const removeParagraph = (index) => {
// //     const newParagraphs = aboutData.paragraphs.filter((_, i) => i !== index);
// //     setAboutData({ ...aboutData, paragraphs: newParagraphs });
// //   };

// //   const startEditing = (index) => {
// //     setEditingIndex(index);
// //   };

// //   const stopEditing = () => {
// //     setEditingIndex(null);
// //   };

// //   const handleImageUpload = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       setImageUploading(true);
      
// //       // Symulacja procesu uploadu (w rzeczywistości wysłałbyś plik na serwer)
// //       setTimeout(() => {
// //         const reader = new FileReader();
// //         reader.onload = (event) => {
// //           // W rzeczywistej aplikacji, tutaj zapisałbyś URL zwrócony przez serwer
// //           const newImageUrl = event.target.result;
// //           setAboutData({
// //             ...aboutData,
// //             images: [...aboutData.images, newImageUrl]
// //           });
// //           setImageUploading(false);
// //         };
// //         reader.readAsDataURL(file);
// //       }, 1000);
// //     }
// //   };

// //   const removeImage = (index) => {
// //     const newImages = aboutData.images.filter((_, i) => i !== index);
// //     setAboutData({ ...aboutData, images: newImages });
// //   };

// //   const moveImage = (index, direction) => {
// //     if ((direction === 'up' && index === 0) || 
// //         (direction === 'down' && index === aboutData.images.length - 1)) {
// //       return;
// //     }

// //     const newImages = [...aboutData.images];
// //     const targetIndex = direction === 'up' ? index - 1 : index + 1;
    
// //     [newImages[index], newImages[targetIndex]] = 
// //     [newImages[targetIndex], newImages[index]];
    
// //     setAboutData({ ...aboutData, images: newImages });
// //   };

// //   return (
// //     <div className="min-h-screen bg-gray-100 p-6">
// //       <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
// //         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja O nas</h1>
        
// //         {message && (
// //           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
// //             {message}
// //           </div>
// //         )}
        
// //         {/* Edycja tytułu */}
// //         <div className="mb-6">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
// //           <input
// //             type="text"
// //             value={aboutData.title}
// //             onChange={handleTitleChange}
// //             className="w-full p-3 border border-gray-300 rounded-md"
// //           />
// //         </div>
        
// //         {/* Edycja paragrafów */}
// //         <div className="mb-6">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Paragrafy</label>
// //           <div className="space-y-4">
// //             {aboutData.paragraphs.map((paragraph, index) => (
// //               <div key={index} className="flex items-start gap-2">
// //                 {editingIndex === index ? (
// //                   <>
// //                     <textarea
// //                       value={paragraph}
// //                       onChange={(e) => handleParagraphChange(index, e.target.value)}
// //                       className="flex-1 p-3 border border-gray-300 rounded-md h-32"
// //                     />
// //                     <button
// //                       onClick={stopEditing}
// //                       className="p-2 bg-blue-500 text-white rounded-md mt-2"
// //                     >
// //                       Zapisz
// //                     </button>
// //                   </>
// //                 ) : (
// //                   <>
// //                     <div className="flex-1 p-3 bg-gray-50 rounded-md">
// //                       <p className="whitespace-pre-wrap">{paragraph}</p>
// //                     </div>
// //                     <div className="flex flex-col gap-2">
// //                       <button
// //                         onClick={() => startEditing(index)}
// //                         className="p-2 bg-gray-200 rounded-md"
// //                         title="Edytuj"
// //                       >
// //                         <FaEdit />
// //                       </button>
// //                       <button
// //                         onClick={() => removeParagraph(index)}
// //                         className="p-2 bg-red-100 text-red-600 rounded-md"
// //                         title="Usuń"
// //                       >
// //                         <FaTrash />
// //                       </button>
// //                     </div>
// //                   </>
// //                 )}
// //               </div>
// //             ))}
// //           </div>
          
// //           <div className="mt-4 flex gap-2">
// //             <textarea
// //               value={newParagraph}
// //               onChange={(e) => setNewParagraph(e.target.value)}
// //               placeholder="Dodaj nowy paragraf..."
// //               className="flex-1 p-3 border border-gray-300 rounded-md h-32"
// //             />
// //             <button
// //               onClick={addParagraph}
// //               className="p-3 bg-blue-500 text-white rounded-md self-start flex items-center gap-2"
// //             >
// //               <FaPlus /> Dodaj
// //             </button>
// //           </div>
// //         </div>
        
// //         {/* Tekst pogrubiony */}
// //         <div className="mb-6">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Tekst pogrubiony</label>
// //           <textarea
// //             value={aboutData.boldText}
// //             onChange={handleBoldTextChange}
// //             className="w-full p-3 border border-gray-300 rounded-md h-32"
// //           />
// //         </div>
        
// //         {/* Zarządzanie obrazami */}
// //         <div className="mb-6">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Obrazy</label>
// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
// //             {aboutData.images.map((image, index) => (
// //               <div key={index} className="border rounded-md overflow-hidden relative group">
// //                 <img 
// //                   src={image} 
// //                   alt={`O nas ${index + 1}`} 
// //                   className="w-full h-48 object-cover"
// //                 />
// //                 <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
// //                   <button
// //                     onClick={() => moveImage(index, 'up')}
// //                     disabled={index === 0}
// //                     className={`p-2 rounded-md ${index === 0 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
// //                   >
// //                     ↑
// //                   </button>
// //                   <button
// //                     onClick={() => moveImage(index, 'down')}
// //                     disabled={index === aboutData.images.length - 1}
// //                     className={`p-2 rounded-md ${index === aboutData.images.length - 1 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
// //                   >
// //                     ↓
// //                   </button>
// //                   <button
// //                     onClick={() => removeImage(index)}
// //                     className="p-2 bg-red-500 text-white rounded-md"
// //                   >
// //                     <FaTrash />
// //                   </button>
// //                 </div>
// //                 <div className="p-2 bg-white text-center text-sm truncate">
// //                   {image}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
          
// //           <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
// //             {imageUploading ? (
// //               <div className="flex flex-col items-center justify-center">
// //                 <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
// //                 <span>Przesyłanie...</span>
// //               </div>
// //             ) : (
// //               <>
// //                 <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
// //                 <p className="text-sm text-gray-500">
// //                   <span className="font-semibold">Kliknij aby przesłać</span> lub przeciągnij i upuść
// //                 </p>
// //                 <p className="text-xs text-gray-500">PNG, JPG, GIF (max. 5MB)</p>
// //                 <input 
// //                   type="file" 
// //                   className="hidden" 
// //                   onChange={handleImageUpload} 
// //                   accept="image/*" 
// //                 />
// //               </>
// //             )}
// //           </label>
// //         </div>
        
// //         {/* Podgląd */}
// //         <div className="mb-6 p-4 bg-gray-50 rounded-md">
// //           <h2 className="text-lg font-semibold mb-3">Podgląd sekcji</h2>
// //           <div className="p-4 bg-white rounded-md border">
// //             <section className="py-12 bg-[#edece8]">
// //               <div className="max-w-6xl mx-auto px-4">
// //                 <div className="flex flex-col md:flex-row gap-8 items-center">
// //                   <div className="w-full md:w-1/2 text-left">
// //                     <h2 className="text-3xl font-bold mb-4">{aboutData.title}</h2>
// //                     <div className="text-lg leading-10">
// //                       {aboutData.paragraphs.map((paragraph, index) => (
// //                         <p key={index}>{paragraph}</p>
// //                       ))}
// //                       <p><b>{aboutData.boldText}</b></p>
// //                     </div>
// //                   </div>
// //                   <div className="w-full md:w-1/2 flex flex-col gap-12">
// //                     {aboutData.images.map((image, index) => (
// //                       <img
// //                         key={index}
// //                         src={image}
// //                         alt="O nas"
// //                         className="rounded-lg shadow-md object-cover w-full h-auto"
// //                       />
// //                     ))}
// //                   </div>
// //                 </div>
// //               </div>
// //             </section>
// //           </div>
// //         </div>
        
// //         {/* Przycisk zapisu */}
// //         <div className="flex justify-end">
// //           <button
// //             onClick={saveData}
// //             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
// //           >
// //             <FaSave /> Zapisz zmiany
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AdminPanel;

// // import React, { useState, useEffect } from 'react';
// // import { FaSave, FaPlus, FaTrash, FaUpload, FaEdit, FaBold, FaItalic, FaFont } from 'react-icons/fa';

// // const AdminPanel = () => {
// //   // Stan dla treści i obrazów
// //   const [aboutData, setAboutData] = useState({
// //     title: "O nas",
// //     titleStyle: { fontSize: "2.25rem", fontWeight: "bold" },
// //     paragraphs: [
// //       {
// //         text: "Jeśli marzysz o wypoczynku nad morzem z rodziną, Kolorowe Domki to idealne miejsce! Już od 2013 roku zapewniamy niezapomnianą atmosferę naszym Gościom – zarówno najmłodszym, jak i starszym. Oferujemy komfortowe drewniane domki dla 4-6 osób oraz przestronne Apartamenty Kolorowe Domki dla 4-8 osób.",
// //         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
// //       },
// //       {
// //         text: "Nasze obiekty znajdują się w malowniczej Jastrzębiej Górze, w pobliżu Rozewia i jego latarni morskiej. Spokojna okolica sprzyja relaksowi, a bliskość plaży oraz tras pieszych i rowerowych gwarantuje aktywny wypoczynek. W okresie letnim organizujemy specjalne atrakcje: dzień z naleśnikami dla dzieci i wieczory z rybami dla dorosłych.",
// //         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
// //       },
// //       {
// //         text: "Gościom zapewniamy miejsce parkingowe oraz przestrzeń do zabawy i grillowania. Do plaży prowadzą wygodne zejścia – wybetonowane nr 20 oraz malownicze „Lisi Jar” nr 19.",
// //         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
// //       },
// //       {
// //         text: "Zapraszamy na rodzinny wypoczynek nad morzem!",
// //         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
// //       }
// //     ],
// //     boldText: {
// //       text: "Zapewniamy miejsca parkingowe dla naszych Gości w cenie wynajmu.",
// //       style: { fontSize: "1.125rem", fontWeight: "bold", fontStyle: "normal" }
// //     },
// //     images: [
// //       "/images/aboutuspicture1.jpg",
// //       "/images/aboutuspicture2.jpg"
// //     ]
// //   });

// //   const [newParagraph, setNewParagraph] = useState({ text: "", style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } });
// //   const [editingIndex, setEditingIndex] = useState(null);
// //   const [message, setMessage] = useState("");
// //   const [imageUploading, setImageUploading] = useState(false);
// //   const [fontSizes] = useState([
// //     { value: "0.75rem", label: "Mała" },
// //     { value: "1rem", label: "Normalna" },
// //     { value: "1.125rem", label: "Średnia" },
// //     { value: "1.25rem", label: "Duża" },
// //     { value: "1.5rem", label: "Bardzo duża" }
// //   ]);

// //   // Załaduj dane z localStorage przy starcie
// //   useEffect(() => {
// //     const savedData = localStorage.getItem('aboutData');
// //     if (savedData) {
// //       setAboutData(JSON.parse(savedData));
// //     }
// //   }, []);

// //   const saveData = () => {
// //     localStorage.setItem('aboutData', JSON.stringify(aboutData));
// //     setMessage("Zmiany zapisane pomyślnie!");
// //     setTimeout(() => setMessage(""), 3000);
// //   };

// //   const handleTitleChange = (e) => {
// //     setAboutData({ ...aboutData, title: e.target.value });
// //   };

// //   const handleTitleStyleChange = (property, value) => {
// //     setAboutData({ 
// //       ...aboutData, 
// //       titleStyle: { ...aboutData.titleStyle, [property]: value } 
// //     });
// //   };

// //   const handleParagraphChange = (index, value) => {
// //     const newParagraphs = [...aboutData.paragraphs];
// //     newParagraphs[index].text = value;
// //     setAboutData({ ...aboutData, paragraphs: newParagraphs });
// //   };

// //   const handleParagraphStyleChange = (index, property, value) => {
// //     const newParagraphs = [...aboutData.paragraphs];
// //     newParagraphs[index].style = { ...newParagraphs[index].style, [property]: value };
// //     setAboutData({ ...aboutData, paragraphs: newParagraphs });
// //   };

// //   const handleBoldTextChange = (e) => {
// //     setAboutData({ 
// //       ...aboutData, 
// //       boldText: { ...aboutData.boldText, text: e.target.value } 
// //     });
// //   };

// //   const handleBoldTextStyleChange = (property, value) => {
// //     setAboutData({ 
// //       ...aboutData, 
// //       boldText: { ...aboutData.boldText, style: { ...aboutData.boldText.style, [property]: value } } 
// //     });
// //   };

// //   const addParagraph = () => {
// //     if (newParagraph.text.trim()) {
// //       setAboutData({
// //         ...aboutData,
// //         paragraphs: [...aboutData.paragraphs, { ...newParagraph }]
// //       });
// //       setNewParagraph({ text: "", style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } });
// //     }
// //   };

// //   const removeParagraph = (index) => {
// //     const newParagraphs = aboutData.paragraphs.filter((_, i) => i !== index);
// //     setAboutData({ ...aboutData, paragraphs: newParagraphs });
// //   };

// //   const startEditing = (index) => {
// //     setEditingIndex(index);
// //   };

// //   const stopEditing = () => {
// //     setEditingIndex(null);
// //   };

// //   const handleImageUpload = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       setImageUploading(true);
      
// //       // Symulacja procesu uploadu
// //       setTimeout(() => {
// //         const reader = new FileReader();
// //         reader.onload = (event) => {
// //           const newImageUrl = event.target.result;
// //           setAboutData({
// //             ...aboutData,
// //             images: [...aboutData.images, newImageUrl]
// //           });
// //           setImageUploading(false);
// //         };
// //         reader.readAsDataURL(file);
// //       }, 1000);
// //     }
// //   };

// //   const removeImage = (index) => {
// //     const newImages = aboutData.images.filter((_, i) => i !== index);
// //     setAboutData({ ...aboutData, images: newImages });
// //   };

// //   const moveImage = (index, direction) => {
// //     if ((direction === 'up' && index === 0) || 
// //         (direction === 'down' && index === aboutData.images.length - 1)) {
// //       return;
// //     }

// //     const newImages = [...aboutData.images];
// //     const targetIndex = direction === 'up' ? index - 1 : index + 1;
    
// //     [newImages[index], newImages[targetIndex]] = 
// //     [newImages[targetIndex], newImages[index]];
    
// //     setAboutData({ ...aboutData, images: newImages });
// //   };

// //   // Funkcja do renderowania kontrolek stylu
// //   const renderStyleControls = (style, onChange) => (
// //     <div className="flex gap-2 mb-2">
// //       <select
// //         value={style.fontSize}
// //         onChange={(e) => onChange('fontSize', e.target.value)}
// //         className="p-1 border border-gray-300 rounded text-sm"
// //       >
// //         {fontSizes.map((size) => (
// //           <option key={size.value} value={size.value}>
// //             {size.label}
// //           </option>
// //         ))}
// //       </select>
      
// //       <button
// //         onClick={() => onChange('fontWeight', style.fontWeight === 'bold' ? 'normal' : 'bold')}
// //         className={`p-1 rounded ${style.fontWeight === 'bold' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
// //         title="Pogrubienie"
// //       >
// //         <FaBold />
// //       </button>
      
// //       <button
// //         onClick={() => onChange('fontStyle', style.fontStyle === 'italic' ? 'normal' : 'italic')}
// //         className={`p-1 rounded ${style.fontStyle === 'italic' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
// //         title="Kursywa"
// //       >
// //         <FaItalic />
// //       </button>
// //     </div>
// //   );

// //   return (
// //     <div className="min-h-screen bg-gray-100 p-6">
// //       <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
// //         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja O nas</h1>
        
// //         {message && (
// //           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
// //             {message}
// //           </div>
// //         )}
        
// //         {/* Edycja tytułu */}
// //         <div className="mb-6 p-4 border border-gray-200 rounded-md">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
// //           {renderStyleControls(aboutData.titleStyle, (property, value) => 
// //             handleTitleStyleChange(property, value)
// //           )}
// //           <input
// //             type="text"
// //             value={aboutData.title}
// //             onChange={handleTitleChange}
// //             className="w-full p-3 border border-gray-300 rounded-md"
// //             style={aboutData.titleStyle}
// //           />
// //         </div>
        
// //         {/* Edycja paragrafów */}
// //         <div className="mb-6">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Paragrafy</label>
// //           <div className="space-y-4">
// //             {aboutData.paragraphs.map((paragraph, index) => (
// //               <div key={index} className="p-4 border border-gray-200 rounded-md">
// //                 {renderStyleControls(paragraph.style, (property, value) => 
// //                   handleParagraphStyleChange(index, property, value)
// //                 )}
                
// //                 {editingIndex === index ? (
// //                   <>
// //                     <textarea
// //                       value={paragraph.text}
// //                       onChange={(e) => handleParagraphChange(index, e.target.value)}
// //                       className="w-full p-3 border border-gray-300 rounded-md h-32"
// //                       style={paragraph.style}
// //                     />
// //                     <div className="mt-2 flex justify-end">
// //                       <button
// //                         onClick={stopEditing}
// //                         className="p-2 bg-blue-500 text-white rounded-md"
// //                       >
// //                         Zapisz
// //                       </button>
// //                     </div>
// //                   </>
// //                 ) : (
// //                   <>
// //                     <div className="p-3 bg-gray-50 rounded-md mb-2">
// //                       <p className="whitespace-pre-wrap" style={paragraph.style}>{paragraph.text}</p>
// //                     </div>
// //                     <div className="flex justify-end gap-2">
// //                       <button
// //                         onClick={() => startEditing(index)}
// //                         className="p-2 bg-gray-200 rounded-md"
// //                         title="Edytuj"
// //                       >
// //                         <FaEdit />
// //                       </button>
// //                       <button
// //                         onClick={() => removeParagraph(index)}
// //                         className="p-2 bg-red-100 text-red-600 rounded-md"
// //                         title="Usuń"
// //                       >
// //                         <FaTrash />
// //                       </button>
// //                     </div>
// //                   </>
// //                 )}
// //               </div>
// //             ))}
// //           </div>
          
// //           <div className="mt-4 p-4 border border-gray-200 rounded-md">
// //             <h3 className="text-sm font-medium text-gray-700 mb-2">Dodaj nowy paragraf</h3>
// //             {renderStyleControls(newParagraph.style, (property, value) => 
// //               setNewParagraph({ 
// //                 ...newParagraph, 
// //                 style: { ...newParagraph.style, [property]: value } 
// //               })
// //             )}
// //             <textarea
// //               value={newParagraph.text}
// //               onChange={(e) => setNewParagraph({ ...newParagraph, text: e.target.value })}
// //               placeholder="Dodaj nowy paragraf..."
// //               className="w-full p-3 border border-gray-300 rounded-md h-32"
// //               style={newParagraph.style}
// //             />
// //             <div className="mt-2 flex justify-end">
// //               <button
// //                 onClick={addParagraph}
// //                 className="p-2 bg-blue-500 text-white rounded-md flex items-center gap-2"
// //               >
// //                 <FaPlus /> Dodaj paragraf
// //               </button>
// //             </div>
// //           </div>
// //         </div>
        
// //         {/* Tekst pogrubiony */}
// //         <div className="mb-6 p-4 border border-gray-200 rounded-md">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Tekst pogrubiony</label>
// //           {renderStyleControls(aboutData.boldText.style, (property, value) => 
// //             handleBoldTextStyleChange(property, value)
// //           )}
// //           <textarea
// //             value={aboutData.boldText.text}
// //             onChange={handleBoldTextChange}
// //             className="w-full p-3 border border-gray-300 rounded-md h-32"
// //             style={aboutData.boldText.style}
// //           />
// //         </div>
        
// //         {/* Zarządzanie obrazami */}
// //         <div className="mb-6">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Obrazy</label>
// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
// //             {aboutData.images.map((image, index) => (
// //               <div key={index} className="border rounded-md overflow-hidden relative group">
// //                 <img 
// //                   src={image} 
// //                   alt={`O nas ${index + 1}`} 
// //                   className="w-full h-48 object-cover"
// //                 />
// //                 <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
// //                   <button
// //                     onClick={() => moveImage(index, 'up')}
// //                     disabled={index === 0}
// //                     className={`p-2 rounded-md ${index === 0 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
// //                   >
// //                     ↑
// //                   </button>
// //                   <button
// //                     onClick={() => moveImage(index, 'down')}
// //                     disabled={index === aboutData.images.length - 1}
// //                     className={`p-2 rounded-md ${index === aboutData.images.length - 1 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
// //                   >
// //                     ↓
// //                   </button>
// //                   <button
// //                     onClick={() => removeImage(index)}
// //                     className="p-2 bg-red-500 text-white rounded-md"
// //                   >
// //                     <FaTrash />
// //                   </button>
// //                 </div>
// //                 <div className="p-2 bg-white text-center text-sm truncate">
// //                   {image}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
          
// //           <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
// //             {imageUploading ? (
// //               <div className="flex flex-col items-center justify-center">
// //                 <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
// //                 <span>Przesyłanie...</span>
// //               </div>
// //             ) : (
// //               <>
// //                 <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
// //                 <p className="text-sm text-gray-500">
// //                   <span className="font-semibold">Kliknij aby przesłać</span> lub przeciągnij i upuść
// //                 </p>
// //                 <p className="text-xs text-gray-500">PNG, JPG, GIF (max. 5MB)</p>
// //                 <input 
// //                   type="file" 
// //                   className="hidden" 
// //                   onChange={handleImageUpload} 
// //                   accept="image/*" 
// //                 />
// //               </>
// //             )}
// //           </label>
// //         </div>
        
// //         {/* Podgląd */}
// //         <div className="mb-6 p-4 bg-gray-50 rounded-md">
// //           <h2 className="text-lg font-semibold mb-3">Podgląd sekcji</h2>
// //           <div className="p-4 bg-white rounded-md border">
// //             <section className="py-12 bg-[#edece8]">
// //               <div className="max-w-6xl mx-auto px-4">
// //                 <div className="flex flex-col md:flex-row gap-8 items-center">
// //                   <div className="w-full md:w-1/2 text-left">
// //                     <h2 className="text-3xl font-bold mb-4" style={aboutData.titleStyle}>
// //                       {aboutData.title}
// //                     </h2>
// //                     <div className="text-lg leading-10">
// //                       {aboutData.paragraphs.map((paragraph, index) => (
// //                         <p key={index} style={paragraph.style}>{paragraph.text}</p>
// //                       ))}
// //                       <p style={aboutData.boldText.style}>
// //                         <b>{aboutData.boldText.text}</b>
// //                       </p>
// //                     </div>
// //                   </div>
// //                   <div className="w-full md:w-1/2 flex flex-col gap-12">
// //                     {aboutData.images.map((image, index) => (
// //                       <img
// //                         key={index}
// //                         src={image}
// //                         alt="O nas"
// //                         className="rounded-lg shadow-md object-cover w-full h-auto"
// //                       />
// //                     ))}
// //                   </div>
// //                 </div>
// //               </div>
// //             </section>
// //           </div>
// //         </div>
        
// //         {/* Przycisk zapisu */}
// //         <div className="flex justify-end">
// //           <button
// //             onClick={saveData}
// //             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
// //           >
// //             <FaSave /> Zapisz zmiany
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AdminPanel;


// // import React, { useState, useEffect } from 'react';
// // import { FaSave, FaPlus, FaTrash, FaUpload, FaEdit, FaBold, FaItalic, FaFont } from 'react-icons/fa';

// // const AdminAboutPanel = () => {
// //   // Domyślna struktura danych
// //   const defaultAboutData = {
// //     title: "O nas",
// //     titleStyle: { fontSize: "2.25rem", fontWeight: "bold" },
// //     paragraphs: [
// //       {
// //         text: "Jeśli marzysz o wypoczynku nad morzem z rodziną, Kolorowe Domki to idealne miejsce! Już od 2013 roku zapewniamy niezapomnianą atmosferę naszym Gościom – zarówno najmłodszym, jak i starszym. Oferujemy komfortowe drewniane domki dla 4-6 osób oraz przestronne Apartamenty Kolorowe Domki dla 4-8 osób.",
// //         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
// //       },
// //       {
// //         text: "Nasze obiekty znajdują się w malowniczej Jastrzębiej Górze, w pobliżu Rozewia i jego latarni morskiej. Spokojna okolica sprzyja relaksowi, a bliskość plaży oraz tras pieszych i rowerowych gwarantuje aktywny wypoczynek. W okresie letnim organizujemy specjalne atrakcje: dzień z naleśnikami dla dzieci i wieczory z rybami dla dorosłych.",
// //         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
// //       },
// //       {
// //         text: "Gościom zapewniamy miejsce parkingowe oraz przestrzeń do zabawy i grillowania. Do plaży prowadzą wygodne zejścia – wybetonowane nr 20 oraz malownicze „Lisi Jar” nr 19.",
// //         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
// //       },
// //       {
// //         text: "Zapraszamy na rodzinny wypoczynek nad morzem!",
// //         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
// //       }
// //     ],
// //     boldText: {
// //       text: "Zapewniamy miejsca parkingowe dla naszych Gości w cenie wynajmu.",
// //       style: { fontSize: "1.125rem", fontWeight: "bold", fontStyle: "normal" }
// //     },
// //     images: [
// //       "/images/aboutuspicture1.jpg",
// //       "/images/aboutuspicture2.jpg"
// //     ]
// //   };

// //   const [aboutData, setAboutData] = useState(defaultAboutData);
// //   const [newParagraph, setNewParagraph] = useState({ text: "", style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } });
// //   const [editingIndex, setEditingIndex] = useState(null);
// //   const [message, setMessage] = useState("");
// //   const [imageUploading, setImageUploading] = useState(false);
// //   const [fontSizes] = useState([
// //     { value: "0.75rem", label: "Mała" },
// //     { value: "1rem", label: "Normalna" },
// //     { value: "1.125rem", label: "Średnia" },
// //     { value: "1.25rem", label: "Duża" },
// //     { value: "1.5rem", label: "Bardzo duża" }
// //   ]);

// //   // Funkcja migrująca starą strukturę danych do nowej
// //   const migrateOldData = (oldData) => {
// //     // Jeśli dane są w starej formie (tylko tekst)
// //     if (typeof oldData === 'string' || Array.isArray(oldData)) {
// //       return defaultAboutData;
// //     }
    
// //     // Jeśli dane są obiektem, ale brakuje stylów
// //     if (oldData && typeof oldData === 'object') {
// //       const migratedData = { ...defaultAboutData, ...oldData };
      
// //       // Upewnij się, że titleStyle istnieje
// //       if (!migratedData.titleStyle) {
// //         migratedData.titleStyle = { ...defaultAboutData.titleStyle };
// //       }
      
// //       // Upewnij się, że paragraphs mają właściwą strukturę
// //       if (Array.isArray(migratedData.paragraphs)) {
// //         migratedData.paragraphs = migratedData.paragraphs.map((para, index) => {
// //           if (typeof para === 'string') {
// //             // Stara struktura - zamień na nową
// //             return {
// //               text: para,
// //               style: { ...defaultAboutData.paragraphs[0]?.style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } }
// //             };
// //           }
// //           // Nowa struktura, ale upewnij się, że style istnieje
// //           return {
// //             ...para,
// //             style: para.style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
// //           };
// //         });
// //       }
      
// //       // Upewnij się, że boldText ma właściwą strukturę
// //       if (migratedData.boldText && typeof migratedData.boldText === 'string') {
// //         // Stara struktura - zamień na nową
// //         migratedData.boldText = {
// //           text: migratedData.boldText,
// //           style: { ...defaultAboutData.boldText.style }
// //         };
// //       } else if (migratedData.boldText && typeof migratedData.boldText === 'object') {
// //         // Nowa struktura, ale upewnij się, że style istnieje
// //         migratedData.boldText = {
// //           text: migratedData.boldText.text || "",
// //           style: migratedData.boldText.style || { ...defaultAboutData.boldText.style }
// //         };
// //       }
      
// //       return migratedData;
// //     }
    
// //     return defaultAboutData;
// //   };

// //   // Załaduj dane z localStorage przy starcie
// //   useEffect(() => {
// //     const savedData = localStorage.getItem('aboutData');
// //     if (savedData) {
// //       try {
// //         const parsedData = JSON.parse(savedData);
// //         const migratedData = migrateOldData(parsedData);
// //         setAboutData(migratedData);
// //       } catch (error) {
// //         console.error('Błąd parsowania danych:', error);
// //         setAboutData(defaultAboutData);
// //       }
// //     }
// //   }, []);

// //   const saveData = () => {
// //     localStorage.setItem('aboutData', JSON.stringify(aboutData));
// //     setMessage("Zmiany zapisane pomyślnie!");
// //     setTimeout(() => setMessage(""), 3000);
// //   };

// //   const handleTitleChange = (e) => {
// //     setAboutData({ ...aboutData, title: e.target.value });
// //   };

// //   const handleTitleStyleChange = (property, value) => {
// //     setAboutData({ 
// //       ...aboutData, 
// //       titleStyle: { ...aboutData.titleStyle, [property]: value } 
// //     });
// //   };

// //   const handleParagraphChange = (index, value) => {
// //     const newParagraphs = [...aboutData.paragraphs];
// //     newParagraphs[index].text = value;
// //     setAboutData({ ...aboutData, paragraphs: newParagraphs });
// //   };

// //   const handleParagraphStyleChange = (index, property, value) => {
// //     const newParagraphs = [...aboutData.paragraphs];
// //     newParagraphs[index].style = { ...newParagraphs[index].style, [property]: value };
// //     setAboutData({ ...aboutData, paragraphs: newParagraphs });
// //   };

// //   const handleBoldTextChange = (e) => {
// //     setAboutData({ 
// //       ...aboutData, 
// //       boldText: { ...aboutData.boldText, text: e.target.value } 
// //     });
// //   };

// //   const handleBoldTextStyleChange = (property, value) => {
// //     setAboutData({ 
// //       ...aboutData, 
// //       boldText: { ...aboutData.boldText, style: { ...aboutData.boldText.style, [property]: value } } 
// //     });
// //   };

// //   const addParagraph = () => {
// //     if (newParagraph.text.trim()) {
// //       setAboutData({
// //         ...aboutData,
// //         paragraphs: [...aboutData.paragraphs, { ...newParagraph }]
// //       });
// //       setNewParagraph({ text: "", style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } });
// //     }
// //   };

// //   const removeParagraph = (index) => {
// //     const newParagraphs = aboutData.paragraphs.filter((_, i) => i !== index);
// //     setAboutData({ ...aboutData, paragraphs: newParagraphs });
// //   };

// //   const startEditing = (index) => {
// //     setEditingIndex(index);
// //   };

// //   const stopEditing = () => {
// //     setEditingIndex(null);
// //   };

// //   const handleImageUpload = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       setImageUploading(true);
      
// //       // Symulacja procesu uploadu
// //       setTimeout(() => {
// //         const reader = new FileReader();
// //         reader.onload = (event) => {
// //           const newImageUrl = event.target.result;
// //           setAboutData({
// //             ...aboutData,
// //             images: [...aboutData.images, newImageUrl]
// //           });
// //           setImageUploading(false);
// //         };
// //         reader.readAsDataURL(file);
// //       }, 1000);
// //     }
// //   };

// //   const removeImage = (index) => {
// //     const newImages = aboutData.images.filter((_, i) => i !== index);
// //     setAboutData({ ...aboutData, images: newImages });
// //   };

// //   const moveImage = (index, direction) => {
// //     if ((direction === 'up' && index === 0) || 
// //         (direction === 'down' && index === aboutData.images.length - 1)) {
// //       return;
// //     }

// //     const newImages = [...aboutData.images];
// //     const targetIndex = direction === 'up' ? index - 1 : index + 1;
    
// //     [newImages[index], newImages[targetIndex]] = 
// //     [newImages[targetIndex], newImages[index]];
    
// //     setAboutData({ ...aboutData, images: newImages });
// //   };

// //   // Funkcja do renderowania kontrolek stylu z zabezpieczeniem
// //   const renderStyleControls = (style, onChange) => {
// //     // Zabezpieczenie przed undefined style
// //     const safeStyle = style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" };
    
// //     return (
// //       <div className="flex gap-2 mb-2">
// //         <select
// //           value={safeStyle.fontSize || "1.125rem"}
// //           onChange={(e) => onChange('fontSize', e.target.value)}
// //           className="p-1 border border-gray-300 rounded text-sm"
// //         >
// //           {fontSizes.map((size) => (
// //             <option key={size.value} value={size.value}>
// //               {size.label}
// //             </option>
// //           ))}
// //         </select>
        
// //         <button
// //           onClick={() => onChange('fontWeight', safeStyle.fontWeight === 'bold' ? 'normal' : 'bold')}
// //           className={`p-1 rounded ${safeStyle.fontWeight === 'bold' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
// //           title="Pogrubienie"
// //         >
// //           <FaBold />
// //         </button>
        
// //         <button
// //           onClick={() => onChange('fontStyle', safeStyle.fontStyle === 'italic' ? 'normal' : 'italic')}
// //           className={`p-1 rounded ${safeStyle.fontStyle === 'italic' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
// //           title="Kursywa"
// //         >
// //           <FaItalic />
// //         </button>
// //       </div>
// //     );
// //   };

// //   // Funkcja do bezpiecznego wyświetlania stylu
// //   const getSafeStyle = (style) => {
// //     return style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" };
// //   };

// //   return (
// //     <div className="min-h-screen bg-gray-100 p-6">
// //       <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
// //         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja O nas</h1>
        
// //         {message && (
// //           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
// //             {message}
// //           </div>
// //         )}
        
// //         {/* Edycja tytułu */}
// //         <div className="mb-6 p-4 border border-gray-200 rounded-md">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
// //           {renderStyleControls(aboutData.titleStyle, (property, value) => 
// //             handleTitleStyleChange(property, value)
// //           )}
// //           <input
// //             type="text"
// //             value={aboutData.title || ""}
// //             onChange={handleTitleChange}
// //             className="w-full p-3 border border-gray-300 rounded-md"
// //             style={getSafeStyle(aboutData.titleStyle)}
// //           />
// //         </div>
        
// //         {/* Edycja paragrafów */}
// //         <div className="mb-6">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Paragrafy</label>
// //           <div className="space-y-4">
// //             {aboutData.paragraphs && aboutData.paragraphs.map((paragraph, index) => (
// //               <div key={index} className="p-4 border border-gray-200 rounded-md">
// //                 {renderStyleControls(paragraph.style, (property, value) => 
// //                   handleParagraphStyleChange(index, property, value)
// //                 )}
                
// //                 {editingIndex === index ? (
// //                   <>
// //                     <textarea
// //                       value={paragraph.text || ""}
// //                       onChange={(e) => handleParagraphChange(index, e.target.value)}
// //                       className="w-full p-3 border border-gray-300 rounded-md h-32"
// //                       style={getSafeStyle(paragraph.style)}
// //                     />
// //                     <div className="mt-2 flex justify-end">
// //                       <button
// //                         onClick={stopEditing}
// //                         className="p-2 bg-blue-500 text-white rounded-md"
// //                       >
// //                         Zapisz
// //                       </button>
// //                     </div>
// //                   </>
// //                 ) : (
// //                   <>
// //                     <div className="p-3 bg-gray-50 rounded-md mb-2">
// //                       <p className="whitespace-pre-wrap" style={getSafeStyle(paragraph.style)}>
// //                         {paragraph.text || ""}
// //                       </p>
// //                     </div>
// //                     <div className="flex justify-end gap-2">
// //                       <button
// //                         onClick={() => startEditing(index)}
// //                         className="p-2 bg-gray-200 rounded-md"
// //                         title="Edytuj"
// //                       >
// //                         <FaEdit />
// //                       </button>
// //                       <button
// //                         onClick={() => removeParagraph(index)}
// //                         className="p-2 bg-red-100 text-red-600 rounded-md"
// //                         title="Usuń"
// //                       >
// //                         <FaTrash />
// //                       </button>
// //                     </div>
// //                   </>
// //                 )}
// //               </div>
// //             ))}
// //           </div>
          
// //           <div className="mt-4 p-4 border border-gray-200 rounded-md">
// //             <h3 className="text-sm font-medium text-gray-700 mb-2">Dodaj nowy paragraf</h3>
// //             {renderStyleControls(newParagraph.style, (property, value) => 
// //               setNewParagraph({ 
// //                 ...newParagraph, 
// //                 style: { ...newParagraph.style, [property]: value } 
// //               })
// //             )}
// //             <textarea
// //               value={newParagraph.text}
// //               onChange={(e) => setNewParagraph({ ...newParagraph, text: e.target.value })}
// //               placeholder="Dodaj nowy paragraf..."
// //               className="w-full p-3 border border-gray-300 rounded-md h-32"
// //               style={getSafeStyle(newParagraph.style)}
// //             />
// //             <div className="mt-2 flex justify-end">
// //               <button
// //                 onClick={addParagraph}
// //                 className="p-2 bg-blue-500 text-white rounded-md flex items-center gap-2"
// //               >
// //                 <FaPlus /> Dodaj paragraf
// //               </button>
// //             </div>
// //           </div>
// //         </div>
        
// //         {/* Tekst pogrubiony */}
// //         <div className="mb-6 p-4 border border-gray-200 rounded-md">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Tekst pogrubiony</label>
// //           {renderStyleControls(aboutData.boldText?.style, (property, value) => 
// //             handleBoldTextStyleChange(property, value)
// //           )}
// //           <textarea
// //             value={aboutData.boldText?.text || ""}
// //             onChange={handleBoldTextChange}
// //             className="w-full p-3 border border-gray-300 rounded-md h-32"
// //             style={getSafeStyle(aboutData.boldText?.style)}
// //           />
// //         </div>
        
// //         {/* Zarządzanie obrazami */}
// //         <div className="mb-6">
// //           <label className="block text-sm font-medium text-gray-700 mb-2">Obrazy</label>
// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
// //             {aboutData.images && aboutData.images.map((image, index) => (
// //               <div key={index} className="border rounded-md overflow-hidden relative group">
// //                 <img 
// //                   src={image} 
// //                   alt={`O nas ${index + 1}`} 
// //                   className="w-full h-48 object-cover"
// //                 />
// //                 <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
// //                   <button
// //                     onClick={() => moveImage(index, 'up')}
// //                     disabled={index === 0}
// //                     className={`p-2 rounded-md ${index === 0 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
// //                   >
// //                     ↑
// //                   </button>
// //                   <button
// //                     onClick={() => moveImage(index, 'down')}
// //                     disabled={index === aboutData.images.length - 1}
// //                     className={`p-2 rounded-md ${index === aboutData.images.length - 1 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
// //                   >
// //                     ↓
// //                   </button>
// //                   <button
// //                     onClick={() => removeImage(index)}
// //                     className="p-2 bg-red-500 text-white rounded-md"
// //                   >
// //                     <FaTrash />
// //                   </button>
// //                 </div>
// //                 <div className="p-2 bg-white text-center text-sm truncate">
// //                   {image}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
          
// //           <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
// //             {imageUploading ? (
// //               <div className="flex flex-col items-center justify-center">
// //                 <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
// //                 <span>Przesyłanie...</span>
// //               </div>
// //             ) : (
// //               <>
// //                 <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
// //                 <p className="text-sm text-gray-500">
// //                   <span className="font-semibold">Kliknij aby przesłać</span> lub przeciągnij i upuść
// //                 </p>
// //                 <p className="text-xs text-gray-500">PNG, JPG, GIF (max. 5MB)</p>
// //                 <input 
// //                   type="file" 
// //                   className="hidden" 
// //                   onChange={handleImageUpload} 
// //                   accept="image/*" 
// //                 />
// //               </>
// //             )}
// //           </label>
// //         </div>
        
// //         {/* Podgląd */}
// //         <div className="mb-6 p-4 bg-gray-50 rounded-md">
// //           <h2 className="text-lg font-semibold mb-3">Podgląd sekcji</h2>
// //           <div className="p-4 bg-white rounded-md border">
// //             <section className="py-12 bg-[#edece8]">
// //               <div className="max-w-6xl mx-auto px-4">
// //                 <div className="flex flex-col md:flex-row gap-8 items-center">
// //                   <div className="w-full md:w-1/2 text-left">
// //                     <h2 className="text-3xl font-bold mb-4" style={getSafeStyle(aboutData.titleStyle)}>
// //                       {aboutData.title || "O nas"}
// //                     </h2>
// //                     <div className="text-lg leading-10">
// //                       {aboutData.paragraphs && aboutData.paragraphs.map((paragraph, index) => (
// //                         <p key={index} style={getSafeStyle(paragraph.style)}>
// //                           {paragraph.text || ""}
// //                         </p>
// //                       ))}
// //                       <p style={getSafeStyle(aboutData.boldText?.style)}>
// //                         <b>{aboutData.boldText?.text || ""}</b>
// //                       </p>
// //                     </div>
// //                   </div>
// //                   <div className="w-full md:w-1/2 flex flex-col gap-12">
// //                     {aboutData.images && aboutData.images.map((image, index) => (
// //                       <img
// //                         key={index}
// //                         src={image}
// //                         alt="O nas"
// //                         className="rounded-lg shadow-md object-cover w-full h-auto"
// //                       />
// //                     ))}
// //                   </div>
// //                 </div>
// //               </div>
// //             </section>
// //           </div>
// //         </div>
        
// //         {/* Przycisk zapisu */}
// //         <div className="flex justify-end">
// //           <button
// //             onClick={saveData}
// //             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
// //           >
// //             <FaSave /> Zapisz zmiany
// //           </button>
// //         </div>

// //         {/* Przycisk resetu dla bezpieczeństwa */}
// //         <div className="mt-4 flex justify-start">
// //           <button
// //             onClick={() => {
// //               if (window.confirm('Czy na pewno chcesz przywrócić domyślne ustawienia? Utracisz wszystkie zmiany.')) {
// //                 localStorage.removeItem('aboutData');
// //                 setAboutData(defaultAboutData);
// //                 setMessage('Przywrócono domyślne ustawienia');
// //                 setTimeout(() => setMessage(''), 3000);
// //               }
// //             }}
// //             className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded-md"
// //           >
// //             <FaTrash /> Przywróć domyślne ustawienia
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AdminAboutPanel;

// import React, { useState, useEffect } from 'react';
// import { FaSave, FaPlus, FaTrash, FaUpload, FaEdit, FaBold, FaItalic, FaFont } from 'react-icons/fa';

// const AdminAboutPanel = () => {
//   // Domyślna struktura danych
//   const defaultAboutData = {
//     title: "O nas",
//     titleStyle: { fontSize: "2.25rem", fontWeight: "bold" },
//     paragraphs: [
//       {
//         text: "Jeśli marzysz o wypoczynku nad morzem z rodziną, Kolorowe Domki to idealne miejsce! Już od 2013 roku zapewniamy niezapomnianą atmosferę naszym Gościom – zarówno najmłodszym, jak i starszym. Oferujemy komfortowe drewniane domki dla 4-6 osób oraz przestronne Apartamenty Kolorowe Domki dla 4-8 osób.",
//         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
//       },
//       {
//         text: "Nasze obiekty znajdują się w malowniczej Jastrzębiej Górze, w pobliżu Rozewia i jego latarni morskiej. Spokojna okolica sprzyja relaksowi, a bliskość plaży oraz tras pieszych i rowerowych gwarantuje aktywny wypoczynek. W okresie letnim organizujemy specjalne atrakcje: dzień z naleśnikami dla dzieci i wieczory z rybami dla dorosłych.",
//         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
//       },
//       {
//         text: "Gościom zapewniamy miejsce parkingowe oraz przestrzeń do zabawy i grillowania. Do plaży prowadzą wygodne zejścia – wybetonowane nr 20 oraz malownicze „Lisi Jar” nr 19.",
//         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
//       },
//       {
//         text: "Zapraszamy na rodzinny wypoczynek nad morzem!",
//         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
//       }
//     ],
//     boldText: {
//       text: "Zapewniamy miejsca parkingowe dla naszych Gości w cenie wynajmu.",
//       style: { fontSize: "1.125rem", fontWeight: "bold", fontStyle: "normal" }
//     },
//     images: [
//       "/images/aboutuspicture1.jpg",
//       "/images/aboutuspicture2.jpg"
//     ]
//   };

//   const API_BASE = 'http://localhost/api';

//   const [aboutData, setAboutData] = useState(defaultAboutData);
//   const [newParagraph, setNewParagraph] = useState({ text: "", style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } });
//   const [editingIndex, setEditingIndex] = useState(null);
//   const [message, setMessage] = useState("");
//   const [imageUploading, setImageUploading] = useState(false);
//   const [fontSizes] = useState([
//     { value: "0.75rem", label: "Mała" },
//     { value: "1rem", label: "Normalna" },
//     { value: "1.125rem", label: "Średnia" },
//     { value: "1.25rem", label: "Duża" },
//     { value: "1.5rem", label: "Bardzo duża" }
//   ]);

//   // Załaduj dane z serwera
//   useEffect(() => {
//     fetch(`${API_BASE}/about.php`)
//       .then(response => {
//         if (!response.ok) {
//           throw new Error('Błąd sieciowy');
//         }
//         return response.json();
//       })
//       .then(data => {
//         // Sprawdź czy serwer zwrócił dane
//         if (data && !data.error) {
//           const migratedData = migrateOldData(data);
//           setAboutData(migratedData);
//         } else {
//           // Jeśli serwer zwrócił błąd, użyj domyślnych danych
//           console.warn('Serwer zwrócił błąd, używam domyślnych danych');
//           setAboutData(defaultAboutData);
//         }
//       })
//       .catch(error => {
//         console.error('Błąd ładowania danych:', error);
//         setMessage('Błąd połączenia z serwerem - używam domyślnych danych');
//         setTimeout(() => setMessage(""), 5000);
//         setAboutData(defaultAboutData);
//       });
//   }, []);

//   // Funkcja migrująca starą strukturę danych do nowej
//   const migrateOldData = (oldData) => {
//     // Jeśli dane są w starej formie (tylko tekst)
//     if (typeof oldData === 'string' || Array.isArray(oldData)) {
//       return defaultAboutData;
//     }
    
//     // Jeśli dane są obiektem, ale brakuje stylów
//     if (oldData && typeof oldData === 'object') {
//       const migratedData = { ...defaultAboutData, ...oldData };
      
//       // Upewnij się, że titleStyle istnieje
//       if (!migratedData.titleStyle) {
//         migratedData.titleStyle = { ...defaultAboutData.titleStyle };
//       }
      
//       // Upewnij się, że paragraphs mają właściwą strukturę
//       if (Array.isArray(migratedData.paragraphs)) {
//         migratedData.paragraphs = migratedData.paragraphs.map((para, index) => {
//           if (typeof para === 'string') {
//             // Stara struktura - zamień na nową
//             return {
//               text: para,
//               style: { ...defaultAboutData.paragraphs[0]?.style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } }
//             };
//           }
//           // Nowa struktura, ale upewnij się, że style istnieje
//           return {
//             ...para,
//             style: para.style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
//           };
//         });
//       }
      
//       // Upewnij się, że boldText ma właściwą strukturę
//       if (migratedData.boldText && typeof migratedData.boldText === 'string') {
//         // Stara struktura - zamień na nową
//         migratedData.boldText = {
//           text: migratedData.boldText,
//           style: { ...defaultAboutData.boldText.style }
//         };
//       } else if (migratedData.boldText && typeof migratedData.boldText === 'object') {
//         // Nowa struktura, ale upewnij się, że style istnieje
//         migratedData.boldText = {
//           text: migratedData.boldText.text || "",
//           style: migratedData.boldText.style || { ...defaultAboutData.boldText.style }
//         };
//       }
      
//       return migratedData;
//     }
    
//     return defaultAboutData;
//   };

//   // Zapisz dane na serwerze
//   const saveData = () => {
//     fetch(`${API_BASE}/about.php`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(aboutData),
//     })
//     .then(response => {
//       if (!response.ok) {
//         throw new Error('Błąd serwera');
//       }
//       return response.json();
//     })
//     .then(data => {
//       setMessage(data.message || "Zmiany zapisane pomyślnie!");
//       setTimeout(() => setMessage(""), 3000);
//     })
//     .catch(error => {
//       setMessage("Błąd podczas zapisywania danych");
//       console.error('Błąd:', error);
//       setTimeout(() => setMessage(""), 5000);
//     });
//   };

//   const handleTitleChange = (e) => {
//     setAboutData({ ...aboutData, title: e.target.value });
//   };

//   const handleTitleStyleChange = (property, value) => {
//     setAboutData({ 
//       ...aboutData, 
//       titleStyle: { ...aboutData.titleStyle, [property]: value } 
//     });
//   };

//   const handleParagraphChange = (index, value) => {
//     const newParagraphs = [...aboutData.paragraphs];
//     newParagraphs[index].text = value;
//     setAboutData({ ...aboutData, paragraphs: newParagraphs });
//   };

//   const handleParagraphStyleChange = (index, property, value) => {
//     const newParagraphs = [...aboutData.paragraphs];
//     newParagraphs[index].style = { ...newParagraphs[index].style, [property]: value };
//     setAboutData({ ...aboutData, paragraphs: newParagraphs });
//   };

//   const handleBoldTextChange = (e) => {
//     setAboutData({ 
//       ...aboutData, 
//       boldText: { ...aboutData.boldText, text: e.target.value } 
//     });
//   };

//   const handleBoldTextStyleChange = (property, value) => {
//     setAboutData({ 
//       ...aboutData, 
//       boldText: { ...aboutData.boldText, style: { ...aboutData.boldText.style, [property]: value } } 
//     });
//   };

//   const addParagraph = () => {
//     if (newParagraph.text.trim()) {
//       setAboutData({
//         ...aboutData,
//         paragraphs: [...aboutData.paragraphs, { ...newParagraph }]
//       });
//       setNewParagraph({ text: "", style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } });
//     }
//   };

//   const removeParagraph = (index) => {
//     const newParagraphs = aboutData.paragraphs.filter((_, i) => i !== index);
//     setAboutData({ ...aboutData, paragraphs: newParagraphs });
//   };

//   const startEditing = (index) => {
//     setEditingIndex(index);
//   };

//   const stopEditing = () => {
//     setEditingIndex(null);
//   };

//   // Upload obrazków
//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImageUploading(true);
      
//       const formData = new FormData();
//       formData.append('image', file);
      
//       fetch(`${API_BASE}/upload.php`, {
//         method: 'POST',
//         body: formData,
//       })
//       .then(response => {
//         if (!response.ok) {
//           throw new Error('Błąd serwera');
//         }
//         return response.json();
//       })
//       .then(data => {
//         if (data.success) {
//           setAboutData({
//             ...aboutData,
//             images: [...aboutData.images, data.url]
//           });
//           setMessage("Obrazek przesłany pomyślnie!");
//         } else {
//           setMessage(data.error || "Błąd podczas przesyłania obrazka");
//         }
//         setImageUploading(false);
//         setTimeout(() => setMessage(""), 3000);
//       })
//       .catch(error => {
//         setMessage("Błąd podczas przesyłania obrazka");
//         setImageUploading(false);
//         setTimeout(() => setMessage(""), 5000);
//       });
//     }
//   };

//   const removeImage = (index) => {
//     const newImages = aboutData.images.filter((_, i) => i !== index);
//     setAboutData({ ...aboutData, images: newImages });
//   };

//   const moveImage = (index, direction) => {
//     if ((direction === 'up' && index === 0) || 
//         (direction === 'down' && index === aboutData.images.length - 1)) {
//       return;
//     }

//     const newImages = [...aboutData.images];
//     const targetIndex = direction === 'up' ? index - 1 : index + 1;
    
//     [newImages[index], newImages[targetIndex]] = 
//     [newImages[targetIndex], newImages[index]];
    
//     setAboutData({ ...aboutData, images: newImages });
//   };

//   // Funkcja do renderowania kontrolek stylu z zabezpieczeniem
//   const renderStyleControls = (style, onChange) => {
//     // Zabezpieczenie przed undefined style
//     const safeStyle = style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" };
    
//     return (
//       <div className="flex gap-2 mb-2">
//         <select
//           value={safeStyle.fontSize || "1.125rem"}
//           onChange={(e) => onChange('fontSize', e.target.value)}
//           className="p-1 border border-gray-300 rounded text-sm"
//         >
//           {fontSizes.map((size) => (
//             <option key={size.value} value={size.value}>
//               {size.label}
//             </option>
//           ))}
//         </select>
        
//         <button
//           onClick={() => onChange('fontWeight', safeStyle.fontWeight === 'bold' ? 'normal' : 'bold')}
//           className={`p-1 rounded ${safeStyle.fontWeight === 'bold' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
//           title="Pogrubienie"
//         >
//           <FaBold />
//         </button>
        
//         <button
//           onClick={() => onChange('fontStyle', safeStyle.fontStyle === 'italic' ? 'normal' : 'italic')}
//           className={`p-1 rounded ${safeStyle.fontStyle === 'italic' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
//           title="Kursywa"
//         >
//           <FaItalic />
//         </button>
//       </div>
//     );
//   };

//   // Funkcja do bezpiecznego wyświetlania stylu
//   const getSafeStyle = (style) => {
//     return style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" };
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
//         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja O nas</h1>
        
//         {message && (
//           <div className={`mb-4 p-3 rounded ${
//             message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
//           }`}>
//             {message}
//           </div>
//         )}
        
//         {/* Edycja tytułu */}
//         <div className="mb-6 p-4 border border-gray-200 rounded-md">
//           <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
//           {renderStyleControls(aboutData.titleStyle, (property, value) => 
//             handleTitleStyleChange(property, value)
//           )}
//           <input
//             type="text"
//             value={aboutData.title || ""}
//             onChange={handleTitleChange}
//             className="w-full p-3 border border-gray-300 rounded-md"
//             style={getSafeStyle(aboutData.titleStyle)}
//           />
//         </div>
        
//         {/* Edycja paragrafów */}
//         <div className="mb-6">
//           <label className="block text-sm font-medium text-gray-700 mb-2">Paragrafy</label>
//           <div className="space-y-4">
//             {aboutData.paragraphs && aboutData.paragraphs.map((paragraph, index) => (
//               <div key={index} className="p-4 border border-gray-200 rounded-md">
//                 {renderStyleControls(paragraph.style, (property, value) => 
//                   handleParagraphStyleChange(index, property, value)
//                 )}
                
//                 {editingIndex === index ? (
//                   <>
//                     <textarea
//                       value={paragraph.text || ""}
//                       onChange={(e) => handleParagraphChange(index, e.target.value)}
//                       className="w-full p-3 border border-gray-300 rounded-md h-32"
//                       style={getSafeStyle(paragraph.style)}
//                     />
//                     <div className="mt-2 flex justify-end">
//                       <button
//                         onClick={stopEditing}
//                         className="p-2 bg-blue-500 text-white rounded-md"
//                       >
//                         Zapisz
//                       </button>
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div className="p-3 bg-gray-50 rounded-md mb-2">
//                       <p className="whitespace-pre-wrap" style={getSafeStyle(paragraph.style)}>
//                         {paragraph.text || ""}
//                       </p>
//                     </div>
//                     <div className="flex justify-end gap-2">
//                       <button
//                         onClick={() => startEditing(index)}
//                         className="p-2 bg-gray-200 rounded-md"
//                         title="Edytuj"
//                       >
//                         <FaEdit />
//                       </button>
//                       <button
//                         onClick={() => removeParagraph(index)}
//                         className="p-2 bg-red-100 text-red-600 rounded-md"
//                         title="Usuń"
//                       >
//                         <FaTrash />
//                       </button>
//                     </div>
//                   </>
//                 )}
//               </div>
//             ))}
//           </div>
          
//           <div className="mt-4 p-4 border border-gray-200 rounded-md">
//             <h3 className="text-sm font-medium text-gray-700 mb-2">Dodaj nowy paragraf</h3>
//             {renderStyleControls(newParagraph.style, (property, value) => 
//               setNewParagraph({ 
//                 ...newParagraph, 
//                 style: { ...newParagraph.style, [property]: value } 
//               })
//             )}
//             <textarea
//               value={newParagraph.text}
//               onChange={(e) => setNewParagraph({ ...newParagraph, text: e.target.value })}
//               placeholder="Dodaj nowy paragraf..."
//               className="w-full p-3 border border-gray-300 rounded-md h-32"
//               style={getSafeStyle(newParagraph.style)}
//             />
//             <div className="mt-2 flex justify-end">
//               <button
//                 onClick={addParagraph}
//                 className="p-2 bg-blue-500 text-white rounded-md flex items-center gap-2"
//               >
//                 <FaPlus /> Dodaj paragraf
//               </button>
//             </div>
//           </div>
//         </div>
        
//         {/* Tekst pogrubiony */}
//         <div className="mb-6 p-4 border border-gray-200 rounded-md">
//           <label className="block text-sm font-medium text-gray-700 mb-2">Tekst pogrubiony</label>
//           {renderStyleControls(aboutData.boldText?.style, (property, value) => 
//             handleBoldTextStyleChange(property, value)
//           )}
//           <textarea
//             value={aboutData.boldText?.text || ""}
//             onChange={handleBoldTextChange}
//             className="w-full p-3 border border-gray-300 rounded-md h-32"
//             style={getSafeStyle(aboutData.boldText?.style)}
//           />
//         </div>
        
//         {/* Zarządzanie obrazami */}
//         <div className="mb-6">
//           <label className="block text-sm font-medium text-gray-700 mb-2">Obrazy</label>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//             {aboutData.images && aboutData.images.map((image, index) => (
//               <div key={index} className="border rounded-md overflow-hidden relative group">
//                 <img 
//                   src={image} 
//                   alt={`O nas ${index + 1}`} 
//                   className="w-full h-48 object-cover"
//                 />
//                 <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
//                   <button
//                     onClick={() => moveImage(index, 'up')}
//                     disabled={index === 0}
//                     className={`p-2 rounded-md ${index === 0 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
//                   >
//                     ↑
//                   </button>
//                   <button
//                     onClick={() => moveImage(index, 'down')}
//                     disabled={index === aboutData.images.length - 1}
//                     className={`p-2 rounded-md ${index === aboutData.images.length - 1 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
//                   >
//                     ↓
//                   </button>
//                   <button
//                     onClick={() => removeImage(index)}
//                     className="p-2 bg-red-500 text-white rounded-md"
//                   >
//                     <FaTrash />
//                   </button>
//                 </div>
//                 <div className="p-2 bg-white text-center text-sm truncate">
//                   {image}
//                 </div>
//               </div>
//             ))}
//           </div>
          
//           <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
//             {imageUploading ? (
//               <div className="flex flex-col items-center justify-center">
//                 <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
//                 <span>Przesyłanie...</span>
//               </div>
//             ) : (
//               <>
//                 <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
//                 <p className="text-sm text-gray-500">
//                   <span className="font-semibold">Kliknij aby przesłać</span> lub przeciągnij i upuść
//                 </p>
//                 <p className="text-xs text-gray-500">PNG, JPG, GIF (max. 5MB)</p>
//                 <input 
//                   type="file" 
//                   className="hidden" 
//                   onChange={handleImageUpload} 
//                   accept="image/*" 
//                 />
//               </>
//             )}
//           </label>
//         </div>
        
//         {/* Podgląd */}
//         <div className="mb-6 p-4 bg-gray-50 rounded-md">
//           <h2 className="text-lg font-semibold mb-3">Podgląd sekcji</h2>
//           <div className="p-4 bg-white rounded-md border">
//             <section className="py-12 bg-[#edece8]">
//               <div className="max-w-6xl mx-auto px-4">
//                 <div className="flex flex-col md:flex-row gap-8 items-center">
//                   <div className="w-full md:w-1/2 text-left">
//                     <h2 className="text-3xl font-bold mb-4" style={getSafeStyle(aboutData.titleStyle)}>
//                       {aboutData.title || "O nas"}
//                     </h2>
//                     <div className="text-lg leading-10">
//                       {aboutData.paragraphs && aboutData.paragraphs.map((paragraph, index) => (
//                         <p key={index} style={getSafeStyle(paragraph.style)}>
//                           {paragraph.text || ""}
//                         </p>
//                       ))}
//                       <p style={getSafeStyle(aboutData.boldText?.style)}>
//                         <b>{aboutData.boldText?.text || ""}</b>
//                       </p>
//                     </div>
//                   </div>
//                   <div className="w-full md:w-1/2 flex flex-col gap-12">
//                     {aboutData.images && aboutData.images.map((image, index) => (
//                       <img
//                         key={index}
//                         src={image}
//                         alt="O nas"
//                         className="rounded-lg shadow-md object-cover w-full h-auto"
//                       />
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </section>
//           </div>
//         </div>
        
//         {/* Przycisk zapisu */}
//         <div className="flex justify-end">
//           <button
//             onClick={saveData}
//             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
//           >
//             <FaSave /> Zapisz zmiany
//           </button>
//         </div>

//         {/* Przycisk resetu dla bezpieczeństwa */}
//         <div className="mt-4 flex justify-start">
//           <button
//             onClick={() => {
//               if (window.confirm('Czy na pewno chcesz przywrócić domyślne ustawienia? Utracisz wszystkie zmiany.')) {
//                 setAboutData(defaultAboutData);
//                 setMessage('Przywrócono domyślne ustawienia (lokalnie)');
//                 setTimeout(() => setMessage(''), 3000);
//               }
//             }}
//             className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded-md"
//           >
//             <FaTrash /> Przywróć domyślne ustawienia
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminAboutPanel;

import React, { useState, useEffect } from 'react';
import { FaSave, FaPlus, FaTrash, FaUpload, FaEdit, FaBold, FaItalic, FaFont } from 'react-icons/fa';

const AdminAboutPanel = () => {
  // Domyślna struktura danych
  const defaultAboutData = {
    title: "O nas",
    titleStyle: { fontSize: "2.25rem", fontWeight: "bold" },
    paragraphs: [
      {
        text: "Jeśli marzysz o wypoczynku nad morzem z rodziną, Kolorowe Domki to idealne miejsce! Już od 2013 roku zapewniamy niezapomnianą atmosferę naszym Gościom – zarówno najmłodszym, jak i starszym. Oferujemy komfortowe drewniane domki dla 4-6 osób oraz przestronne Apartamenty Kolorowe Domki dla 4-8 osób.",
        style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
      },
      {
        text: "Nasze obiekty znajdują się w malowniczej Jastrzębiej Górze, w pobliżu Rozewia i jego latarni morskiej. Spokojna okolica sprzyja relaksowi, a bliskość plaży oraz tras pieszych i rowerowych gwarantuje aktywny wypoczynek. W okresie letnim organizujemy specjalne atrakcje: dzień z naleśnikami dla dzieci i wieczory z rybami dla dorosłych.",
        style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
      },
      {
        text: "Gościom zapewniamy miejsce parkingowe oraz przestrzeń do zabawy i grillowania. Do plaży prowadzą wygodne zejścia – wybetonowane nr 20 oraz malownicze 'Lisi Jar' nr 19.",
        style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
      },
      {
        text: "Zapraszamy na rodzinny wypoczynek nad morzem!",
        style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
      }
    ],
    boldText: {
      text: "Zapewniamy miejsca parkingowe dla naszych Gości w cenie wynajmu.",
      style: { fontSize: "1.125rem", fontWeight: "bold", fontStyle: "normal" }
    },
    images: [
      "/images/aboutuspicture1.jpg",
      "/images/aboutuspicture2.jpg"
    ]
  };

  const API_BASE = '/api/content';

  const [aboutData, setAboutData] = useState(defaultAboutData);
  const [newParagraph, setNewParagraph] = useState({ text: "", style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } });
  const [editingIndex, setEditingIndex] = useState(null);
  const [message, setMessage] = useState("");
  const [imageUploading, setImageUploading] = useState(false);
  const [fontSizes] = useState([
    { value: "0.75rem", label: "Mała" },
    { value: "1rem", label: "Normalna" },
    { value: "1.125rem", label: "Średnia" },
    { value: "1.25rem", label: "Duża" },
    { value: "1.5rem", label: "Bardzo duża" }
  ]);

  // Załaduj dane z serwera
  useEffect(() => {
  fetch(`${API_BASE}/get-about.php`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Błąd sieciowy');
      }
      return response.json();
    })
    .then(data => {
      if (data && !data.error) {
        setAboutData(data);
      } else {
        setAboutData(defaultAboutData);
      }
    })
    .catch(error => {
      console.error('Błąd ładowania danych:', error);
      setAboutData(defaultAboutData);
    });
}, []);

  // Funkcja migrująca starą strukturę danych do nowej
  const migrateOldData = (oldData) => {
    // Jeśli dane są w starej formie (tylko tekst)
    if (typeof oldData === 'string' || Array.isArray(oldData)) {
      return defaultAboutData;
    }
    
    // Jeśli dane są obiektem, ale brakuje stylów
    if (oldData && typeof oldData === 'object') {
      const migratedData = { ...defaultAboutData, ...oldData };
      
      // Upewnij się, że titleStyle istnieje
      if (!migratedData.titleStyle) {
        migratedData.titleStyle = { ...defaultAboutData.titleStyle };
      }
      
      // Upewnij się, że paragraphs mają właściwą strukturę
      if (Array.isArray(migratedData.paragraphs)) {
        migratedData.paragraphs = migratedData.paragraphs.map((para, index) => {
          if (typeof para === 'string') {
            // Stara struktura - zamień na nową
            return {
              text: para,
              style: { ...defaultAboutData.paragraphs[0]?.style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } }
            };
          }
          // Nowa struktura, ale upewnij się, że style istnieje
          return {
            ...para,
            style: para.style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
          };
        });
      }
      
      // Upewnij się, że boldText ma właściwą strukturę
      if (migratedData.boldText && typeof migratedData.boldText === 'string') {
        // Stara struktura - zamień na nową
        migratedData.boldText = {
          text: migratedData.boldText,
          style: { ...defaultAboutData.boldText.style }
        };
      } else if (migratedData.boldText && typeof migratedData.boldText === 'object') {
        // Nowa struktura, ale upewnij się, że style istnieje
        migratedData.boldText = {
          text: migratedData.boldText.text || "",
          style: migratedData.boldText.style || { ...defaultAboutData.boldText.style }
        };
      }
      
      return migratedData;
    }
    
    return defaultAboutData;
  };

  // Zapisz dane na serwerze
const saveData = () => {
  fetch(`${API_BASE}/update-about.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
    },
    body: JSON.stringify(aboutData),
  })
  .then(response => response.json())
  .then(data => {
    setMessage(data.message || "Zmiany zapisane pomyślnie!");
    setTimeout(() => setMessage(""), 3000);
  })
  .catch(error => {
    setMessage("Błąd podczas zapisywania danych");
    console.error('Błąd:', error);
  });
};

  const handleTitleChange = (e) => {
    setAboutData({ ...aboutData, title: e.target.value });
  };

  const handleTitleStyleChange = (property, value) => {
    setAboutData({ 
      ...aboutData, 
      titleStyle: { ...aboutData.titleStyle, [property]: value } 
    });
  };

  const handleParagraphChange = (index, value) => {
    const newParagraphs = [...aboutData.paragraphs];
    newParagraphs[index].text = value;
    setAboutData({ ...aboutData, paragraphs: newParagraphs });
  };

  const handleParagraphStyleChange = (index, property, value) => {
    const newParagraphs = [...aboutData.paragraphs];
    newParagraphs[index].style = { ...newParagraphs[index].style, [property]: value };
    setAboutData({ ...aboutData, paragraphs: newParagraphs });
  };

  const handleBoldTextChange = (e) => {
    setAboutData({ 
      ...aboutData, 
      boldText: { ...aboutData.boldText, text: e.target.value } 
    });
  };

  const handleBoldTextStyleChange = (property, value) => {
    setAboutData({ 
      ...aboutData, 
      boldText: { ...aboutData.boldText, style: { ...aboutData.boldText.style, [property]: value } } 
    });
  };

  const addParagraph = () => {
    if (newParagraph.text.trim()) {
      setAboutData({
        ...aboutData,
        paragraphs: [...aboutData.paragraphs, { ...newParagraph }]
      });
      setNewParagraph({ text: "", style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } });
    }
  };

  const removeParagraph = (index) => {
    const newParagraphs = aboutData.paragraphs.filter((_, i) => i !== index);
    setAboutData({ ...aboutData, paragraphs: newParagraphs });
  };

  const startEditing = (index) => {
    setEditingIndex(index);
  };

  const stopEditing = () => {
    setEditingIndex(null);
  };

  // Upload obrazków z natychmiastowym podglądem lokalnym
  const handleImageUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    setImageUploading(true);
    
    const formData = new FormData();
    formData.append('image', file);
    
    fetch(`${API_BASE}/upload-image.php`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
      },
      body: formData,
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setAboutData(prevData => ({
          ...prevData,
          images: [...prevData.images, data.url]
        }));
        setMessage("Obrazek przesłany pomyślnie!");
      } else {
        setMessage(data.error || "Błąd podczas przesyłania obrazka");
      }
      setImageUploading(false);
    })
    .catch(error => {
      setMessage("Błąd podczas przesyłania obrazka");
      setImageUploading(false);
    });
  }
};
  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImageUploading(true);
      
  //     // Natychmiastowe podgląd lokalny
  //     const localImageUrl = URL.createObjectURL(file);
      
  //     const formData = new FormData();
  //     formData.append('image', file);
      
  //     // Natychmiast dodaj obrazek do podglądu
  //     setAboutData({
  //       ...aboutData,
  //       images: [...aboutData.images, localImageUrl]
  //     });
      
  //     fetch(`${API_BASE}/upload.php`, {
  //       method: 'POST',
  //       body: formData,
  //     })
  //     .then(response => {
  //       if (!response.ok) {
  //         throw new Error('Błąd serwera');
  //       }
  //       return response.json();
  //     })
  //     .then(data => {
  //       if (data.success) {
  //         const serverImageUrl = data.url.startsWith('http') ? data.url : `http://localhost${data.url}`;
          
  //         // Zamień tymczasowy URL na serwerowy
  //         setAboutData(prevData => ({
  //           ...prevData,
  //           images: prevData.images.map(img => 
  //             img === localImageUrl ? serverImageUrl : img
  //           )
  //         }));
          
  //         setMessage("Obrazek przesłany pomyślnie!");
  //       } else {
  //         // Usuń tymczasowy obrazek jeśli upload się nie udał
  //         setAboutData(prevData => ({
  //           ...prevData,
  //           images: prevData.images.filter(img => img !== localImageUrl)
  //         }));
  //         setMessage(data.error || "Błąd podczas przesyłania obrazka");
  //       }
  //       setImageUploading(false);
  //       setTimeout(() => setMessage(""), 3000);
  //     })
  //     .catch(error => {
  //       // Usuń tymczasowy obrazek w przypadku błędu
  //       setAboutData(prevData => ({
  //         ...prevData,
  //         images: prevData.images.filter(img => img !== localImageUrl)
  //       }));
  //       setMessage("Błąd podczas przesyłania obrazka");
  //       setImageUploading(false);
  //       setTimeout(() => setMessage(""), 5000);
  //     })
  //     .finally(() => {
  //       // Zwolnij tymczasowy URL po zakończeniu
  //       setTimeout(() => URL.revokeObjectURL(localImageUrl), 1000);
  //     });
  //   }
  // };

  const removeImage = (index) => {
    const imageUrl = aboutData.images[index];
    
    // Jeśli to tymczasowy URL, zwolnij go
    if (imageUrl.startsWith('blob:')) {
      URL.revokeObjectURL(imageUrl);
    }
    
    const newImages = aboutData.images.filter((_, i) => i !== index);
    setAboutData({ ...aboutData, images: newImages });
  };

  const moveImage = (index, direction) => {
    if ((direction === 'up' && index === 0) || 
        (direction === 'down' && index === aboutData.images.length - 1)) {
      return;
    }

    const newImages = [...aboutData.images];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    
    [newImages[index], newImages[targetIndex]] = 
    [newImages[targetIndex], newImages[index]];
    
    setAboutData({ ...aboutData, images: newImages });
  };

  // Funkcja do renderowania kontrolek stylu z zabezpieczeniem
  const renderStyleControls = (style, onChange) => {
    // Zabezpieczenie przed undefined style
    const safeStyle = style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" };
    
    return (
      <div className="flex gap-2 mb-2">
        <select
          value={safeStyle.fontSize || "1.125rem"}
          onChange={(e) => onChange('fontSize', e.target.value)}
          className="p-1 border border-gray-300 rounded text-sm"
        >
          {fontSizes.map((size) => (
            <option key={size.value} value={size.value}>
              {size.label}
            </option>
          ))}
        </select>
        
        <button
          onClick={() => onChange('fontWeight', safeStyle.fontWeight === 'bold' ? 'normal' : 'bold')}
          className={`p-1 rounded ${safeStyle.fontWeight === 'bold' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
          title="Pogrubienie"
        >
          <FaBold />
        </button>
        
        <button
          onClick={() => onChange('fontStyle', safeStyle.fontStyle === 'italic' ? 'normal' : 'italic')}
          className={`p-1 rounded ${safeStyle.fontStyle === 'italic' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
          title="Kursywa"
        >
          <FaItalic />
        </button>
      </div>
    );
  };

  // Funkcja do bezpiecznego wyświetlania stylu
  const getSafeStyle = (style) => {
    return style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" };
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Sekcja O nas</h1>
        
        {message && (
          <div className={`mb-4 p-3 rounded ${
            message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
          }`}>
            {message}
          </div>
        )}
        
        {/* Edycja tytułu */}
        <div className="mb-6 p-4 border border-gray-200 rounded-md">
          <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł sekcji</label>
          {renderStyleControls(aboutData.titleStyle, (property, value) => 
            handleTitleStyleChange(property, value)
          )}
          <input
            type="text"
            value={aboutData.title || ""}
            onChange={handleTitleChange}
            className="w-full p-3 border border-gray-300 rounded-md"
            style={getSafeStyle(aboutData.titleStyle)}
          />
        </div>
        
        {/* Edycja paragrafów */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Paragrafy</label>
          <div className="space-y-4">
            {aboutData.paragraphs && aboutData.paragraphs.map((paragraph, index) => (
              <div key={index} className="p-4 border border-gray-200 rounded-md">
                {renderStyleControls(paragraph.style, (property, value) => 
                  handleParagraphStyleChange(index, property, value)
                )}
                
                {editingIndex === index ? (
                  <>
                    <textarea
                      value={paragraph.text || ""}
                      onChange={(e) => handleParagraphChange(index, e.target.value)}
                      className="w-full p-3 border border-gray-300 rounded-md h-32"
                      style={getSafeStyle(paragraph.style)}
                    />
                    <div className="mt-2 flex justify-end">
                      <button
                        onClick={stopEditing}
                        className="p-2 bg-blue-500 text-white rounded-md"
                      >
                        Zapisz
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="p-3 bg-gray-50 rounded-md mb-2">
                      <p className="whitespace-pre-wrap" style={getSafeStyle(paragraph.style)}>
                        {paragraph.text || ""}
                      </p>
                    </div>
                    <div className="flex justify-end gap-2">
                      <button
                        onClick={() => startEditing(index)}
                        className="p-2 bg-gray-200 rounded-md"
                        title="Edytuj"
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => removeParagraph(index)}
                        className="p-2 bg-red-100 text-red-600 rounded-md"
                        title="Usuń"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
          
          <div className="mt-4 p-4 border border-gray-200 rounded-md">
            <h3 className="text-sm font-medium text-gray-700 mb-2">Dodaj nowy paragraf</h3>
            {renderStyleControls(newParagraph.style, (property, value) => 
              setNewParagraph({ 
                ...newParagraph, 
                style: { ...newParagraph.style, [property]: value } 
              })
            )}
            <textarea
              value={newParagraph.text}
              onChange={(e) => setNewParagraph({ ...newParagraph, text: e.target.value })}
              placeholder="Dodaj nowy paragraf..."
              className="w-full p-3 border border-gray-300 rounded-md h-32"
              style={getSafeStyle(newParagraph.style)}
            />
            <div className="mt-2 flex justify-end">
              <button
                onClick={addParagraph}
                className="p-2 bg-blue-500 text-white rounded-md flex items-center gap-2"
              >
                <FaPlus /> Dodaj paragraf
              </button>
            </div>
          </div>
        </div>
        
        {/* Tekst pogrubiony */}
        <div className="mb-6 p-4 border border-gray-200 rounded-md">
          <label className="block text-sm font-medium text-gray-700 mb-2">Tekst pogrubiony</label>
          {renderStyleControls(aboutData.boldText?.style, (property, value) => 
            handleBoldTextStyleChange(property, value)
          )}
          <textarea
            value={aboutData.boldText?.text || ""}
            onChange={handleBoldTextChange}
            className="w-full p-3 border border-gray-300 rounded-md h-32"
            style={getSafeStyle(aboutData.boldText?.style)}
          />
        </div>
        
        {/* Zarządzanie obrazami */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Obrazy</label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            {aboutData.images && aboutData.images.map((image, index) => (
              <div key={index} className="border rounded-md overflow-hidden relative group">
                <img 
                  src={image} 
                  alt={`O nas ${index + 1}`} 
                  className="w-full h-48 object-cover"
                  onError={(e) => {
                    // Fallback dla błędów ładowania obrazków
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTIiIGR5PSIuM2VtIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjOTk5Ij5CxIVkIGxhdG93YW5pYSBvYnJhesSFa2E8L3RleHQ+PC9zdmc+';
                  }}
                />
                <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button
                    onClick={() => moveImage(index, 'up')}
                    disabled={index === 0}
                    className={`p-2 rounded-md ${index === 0 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => moveImage(index, 'down')}
                    disabled={index === aboutData.images.length - 1}
                    className={`p-2 rounded-md ${index === aboutData.images.length - 1 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
                  >
                    ↓
                  </button>
                  <button
                    onClick={() => removeImage(index)}
                    className="p-2 bg-red-500 text-white rounded-md"
                  >
                    <FaTrash />
                  </button>
                </div>
                <div className="p-2 bg-white text-center text-sm truncate">
                  {image.startsWith('blob:') ? 'Przesyłanie...' : image}
                </div>
              </div>
            ))}
          </div>
          
          <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
            {imageUploading ? (
              <div className="flex flex-col items-center justify-center">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
                <span>Przesyłanie...</span>
              </div>
            ) : (
              <>
                <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
                <p className="text-sm text-gray-500">
                  <span className="font-semibold">Kliknij aby przesłać</span> lub przeciągnij i upuść
                </p>
                <p className="text-xs text-gray-500">PNG, JPG, GIF (max. 5MB)</p>
                <input 
                  type="file" 
                  className="hidden" 
                  onChange={handleImageUpload} 
                  accept="image/*" 
                />
              </>
            )}
          </label>
        </div>
        
        {/* Podgląd */}
        <div className="mb-6 p-4 bg-gray-50 rounded-md">
          <h2 className="text-lg font-semibold mb-3">Podgląd sekcji</h2>
          <div className="p-4 bg-white rounded-md border">
            <section className="py-12 bg-[#edece8]">
              <div className="max-w-6xl mx-auto px-4">
                <div className="flex flex-col md:flex-row gap-8 items-center">
                  <div className="w-full md:w-1/2 text-left">
                    <h2 className="text-3xl font-bold mb-4" style={getSafeStyle(aboutData.titleStyle)}>
                      {aboutData.title || "O nas"}
                    </h2>
                    <div className="text-lg leading-10">
                      {aboutData.paragraphs && aboutData.paragraphs.map((paragraph, index) => (
                        <p key={index} style={getSafeStyle(paragraph.style)}>
                          {paragraph.text || ""}
                        </p>
                      ))}
                      <p style={getSafeStyle(aboutData.boldText?.style)}>
                        <b>{aboutData.boldText?.text || ""}</b>
                      </p>
                    </div>
                  </div>
                  <div className="w-full md:w-1/2 flex flex-col gap-12">
                    {aboutData.images && aboutData.images.map((image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt="O nas"
                        className="rounded-lg shadow-md object-cover w-full h-auto"
                        onError={(e) => {
                          e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTIiIGR5PSIuM2VtIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjOTk5Ij5CxIVkIGxhdG93YW5pYSBvYnJhesSFa2E8L3RleHQ+PC9zdmc+';
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        
        {/* Przycisk zapisu */}
        <div className="flex justify-end">
          <button
            onClick={saveData}
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
          >
            <FaSave /> Zapisz zmiany
          </button>
        </div>

        {/* Przycisk resetu dla bezpieczeństwa */}
        <div className="mt-4 flex justify-start">
          <button
            onClick={() => {
              if (window.confirm('Czy na pewno chcesz przywrócić domyślne ustawienia? Utracisz wszystkie zmiany.')) {
                setAboutData(defaultAboutData);
                setMessage('Przywrócono domyślne ustawienia (lokalnie)');
                setTimeout(() => setMessage(''), 3000);
              }
            }}
            className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded-md"
          >
            <FaTrash /> Przywróć domyślne ustawienia
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminAboutPanel;